import React from 'react'
import { FlexContainer } from 'heliocor-ui'
import {useDispatch, useSelector} from 'react-redux';
import 'styled-components/macro'

import { SpinnerLogo } from './common';
import { WizardCAFe } from './components/WizardCAFe/WizardCAFe';
import { REQUEST_CHECK_PHASE } from './store/cafe/actionTypes';

const CAFe = () => {
    const dispatch = useDispatch();
    const isAppReady = useSelector(store => store.general?.appIsReady)

    React.useEffect(() => {
        dispatch({ type: REQUEST_CHECK_PHASE});
        console.log('%c (  (  )  )\n ...........\n |         |]\n  \\       / \n  -------\n%cdokstor CAFe ®',
            "color:#fe593b;font-family:Arial;font-size:2rem;-webkit-text-stroke:2px black;font-weight:bold", 
            "font-size: 1rem;-webkit-text-stroke: 1px #fe593b;")
        console.log('%cpowered by Heliocor','color:#fe593b;')
    },[])

    return( 
        <FlexContainer column margin='0 auto' width='fit-content'>
            {isAppReady ? <WizardCAFe /> : <SpinnerLogo dokstor/>}
        </FlexContainer>
    )
}

export default CAFe